import {
  GET_TURNOS,
  GET_TURNOS_FAIL,
  GET_TURNOS_SUCCESS,
} from "../ActionTypes";

const turnosAutoCheckIn = (state, { payload, type }) => {
  switch (type) {
    case GET_TURNOS:
      return {
        ...state, 
        turnosAutoCheckIn: {
            ...state.turnosAutoCheckIn, 
            loading: true, 
            error: false, 
            data: []
        } 
      };
    case GET_TURNOS_SUCCESS:
      return {
        ...state, 
        turnosAutoCheckIn: {
            ...state.turnosAutoCheckIn, 
            loading: false, 
            error: false, 
            data: payload
        } 
      };
    case GET_TURNOS_FAIL:
      return {
        ...state, 
        turnosAutoCheckIn: {
            ...state.turnosAutoCheckIn, 
            loading: false, 
            error: payload, 
            data: []

        } 
      };
 
    default:
      return state;
  }
};

export default turnosAutoCheckIn;
